import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

const DOMstrings = {
	paginationWrapper: '.pagination',
	paginationSlider: '.pagination__slider',
	paginationCenter: '.pagination__center',
	btnNext: '.nav-item.next',
	btnPrev: '.nav-item.prev',
	btnFirst: '.nav-item.first',
	btnLast: '.nav-item.last',
};

const initializePagination = (pageNumber) => {
	document.querySelectorAll(DOMstrings.paginationWrapper).forEach((paginationEl) => {
		const options = {
			modules: [Navigation],
			initialSlide: pageNumber - 1,
			direction: 'vertical',
			loop: false,
			slideToClickedSlide: true,
			mousewheel: true,
			keyboard: true,
			navigation: {
				nextEl: paginationEl.querySelector(DOMstrings.btnNext),
				prevEl: paginationEl.querySelector(DOMstrings.btnPrev),
				disabledClass: 'disabled',
			},
		};

		if (window.innerWidth >= 1024) {
			options.on = {
				click: () => {
					paginationEl.querySelector(DOMstrings.paginationCenter).classList.toggle('open');
				},
			};
		}

		const pageSlider = new Swiper(paginationEl.querySelector(DOMstrings.paginationSlider), options);

		if (paginationEl.querySelector(DOMstrings.btnFirst)) {
			paginationEl.querySelector(DOMstrings.btnFirst).addEventListener('click', () => {
				pageSlider.slideTo(0);
			});
		}

		if (paginationEl.querySelector(DOMstrings.btnLast)) {
			paginationEl.querySelector(DOMstrings.btnLast).addEventListener('click', () => {
				pageSlider.slideTo(pageSlider.slides.length);
			});
		}
	});

	document.dispatchEvent(new CustomEvent('afterPaginationInit'));
};

initializePagination(1);
document.addEventListener('postsLoaded', (e) => {
	initializePagination(e.detail);
});
